import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { usePermissions } from '@/hooks/usePermissions';
import PagePreloader from '@/Components/navigation/PagePreloader';

/**
 * Protege rotas /producao/*: usuarios sem acesso ao modulo de
 * industrializacao (perfil_industrializacao === 'BLOQUEADO' e nao-admin)
 * sao redirecionados. Equivalente ao trecho do router Vue que verifica
 * `to.path.startsWith('/producao')` + `isPerfilBloqueado`.
 */
export function ProducaoRoute() {
  const { isAuthenticated, loading, postLoginRoute } = useAuth();
  const { isPerfilBloqueado } = usePermissions();

  if (loading) {
    return <PagePreloader active={true} />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isPerfilBloqueado) {
    return <Navigate to={postLoginRoute} replace />;
  }

  return <Outlet />;
}
